import { render, staticRenderFns } from "./OrdenServicioView.vue?vue&type=template&id=6afb2e1a"
import script from "./OrdenServicioView.vue?vue&type=script&lang=js"
export * from "./OrdenServicioView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports